"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrategicBasePlanning = void 0;
const PreludeCard_1 = require("../prelude/PreludeCard");
const CardName_1 = require("../../CardName");
const BuildColony_1 = require("../../deferredActions/BuildColony");
const Tags_1 = require("../Tags");
const PlaceCityTile_1 = require("../../deferredActions/PlaceCityTile");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const CardRenderer_1 = require("../render/CardRenderer");
class StrategicBasePlanning extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.STRATEGIC_BASE_PLANNING,
            tags: [Tags_1.Tags.CITY, Tags_1.Tags.BUILDING, Tags_1.Tags.SPACE],
            metadata: {
                cardNumber: 'X65',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.colonies(1).city().br;
                    b.minus().megacredits(3);
                }),
                description: 'Place a colony. Place a city tile. Pay 3 M€.',
            },
        });
    }
    canPlay(player) {
        return player.canAfford(3);
    }
    play(player) {
        const game = player.game;
        game.defer(new BuildColony_1.BuildColony(player, false, 'Select where to build colony'));
        game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 3, { title: 'Select how to pay for prelude', afterPay: () => {
                game.defer(new PlaceCityTile_1.PlaceCityTile(player));
            } }));
        return undefined;
    }
}
exports.StrategicBasePlanning = StrategicBasePlanning;
//# sourceMappingURL=StrategicBasePlanning.js.map